import { FormProvider, useForm } from 'react-hook-form';
import { Stack, Typography } from '@mui/material';
import {
  initialUserFormDetails,
  userFormDetailsSchema,
} from '../UserFormDetails/form-config';
import { useEffect, useMemo } from 'react';

import { JPhoneInput } from '@atoms/JPhoneInput';
import JTextFieldForm from '@atoms/JTextFieldForm';
import Jpaper from '@atoms/JPaper';
import { UserBlockStyled } from '../UserFormRole/user-form-details.styled';
import UserFormDetailsData from '../../models/user-form-details-data';
import { useTranslation } from 'react-i18next';
import useUserMutationContext from '../../hooks/useUserMutationContext';
import { yupResolver } from '@hookform/resolvers/yup';

interface UserFormContactProps {
  handleChange?: (data: UserFormDetailsData, isDirty: boolean) => void;
}
const UserFormContact = ({ handleChange }: UserFormContactProps) => {
  const { t } = useTranslation();
  const { payload, setIsDirty } = useUserMutationContext();

  const methods = useForm<UserFormDetailsData>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: useMemo(
      () => initialUserFormDetails,
      [initialUserFormDetails],
    ),
    resolver: yupResolver(userFormDetailsSchema(t)),
  });
  const { setValue, trigger, getValues, watch, formState } = methods;
  const { isDirty, isValid } = formState;

  useEffect(() => {
    watch(() => {
      if (handleChange) handleChange(getValues(), isDirty);
    });
  }, [watch, isDirty]);
  useEffect(() => {
    if (payload?.userDto) {
      setValue('firstname', payload.userDto.firstname);
      setValue('lastname', payload.userDto.lastname);
      setValue('email', payload.userDto.email);
      setValue('phone', payload.userDto.phone);
      setValue('mobilePhone', payload.userDto.mobilePhone);

      trigger(['email']);
    }
  }, [payload]);

  useEffect(() => {
    setIsDirty(isDirty && isValid);
  }, [isDirty, isValid]);

  return (
    <FormProvider {...methods}>
      <form autoComplete="off" noValidate>
        <Stack gap={2}>
          <UserBlockStyled>
            <Jpaper gap={1} alignItems="stretch" attr={{ fullHeight: true }}>
              <Typography variant="h3" mb={3}>
                {t('CONTACTS')}
              </Typography>
              <JTextFieldForm
                required
                name="email"
                fullWidth
                noBorder
                label={t('EMAIL')}
                InputLabelProps={{
                  shrink: getValues('email') !== '',
                }}
              />
              <JPhoneInput
                value={payload?.userDto.phone}
                specialLabel={t('PHONE_NUMBER') ?? ''}
                onChange={(value) => {
                  if (value !== '')
                    setValue('phone', '+' + value, { shouldDirty: true });
                  else setValue('phone', undefined);
                  trigger('phone');
                }}
              />
              <JPhoneInput
                value={payload?.userDto.mobilePhone}
                specialLabel={t('PHONE_PRO') ?? ''}
                onChange={(value) => {
                  if (value !== '')
                    setValue('mobilePhone', '+' + value, { shouldDirty: true });
                  else setValue('mobilePhone', undefined);
                  trigger('mobilePhone');
                }}
              />
            </Jpaper>
          </UserBlockStyled>
        </Stack>
      </form>
    </FormProvider>
  );
};

export default UserFormContact;
